export default function getConfig(name) {
    return Config[name]
}